//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Howl, Howler } from 'howler';
import Spine from '@/components/Spine';
import SpineOptimized from '@/components/SpineOptimized';

import { GameMode, MAX_MULTIPLIERS, GameStatus, BetType } from './enum';

// Mock/Import domain entities and constants

const ChickenAnimations = {
  IDLE: 'idle',
  JUMP: 'jump',
  JUMP_BIG: 'jump_big',
  VICTORY: 'victiory',
  DEAD: 'dead',
  JACKPOT: 'jackpot'
};
const PlatformAnimations = {
  IDLE_NORMAL: 'idle_normal',
  IDLE_BLUE: 'idle_blue',
  IDLE_PURPLE: 'idle_purple',
  IDLE_GOLD: 'idle_gold',
  WIN: 'win',
  WIN_GOLD: 'win_gold',
  LOSE: 'lose',
  LOSE_GOLD: 'lose_gold'
};
const TrainAnimations = { GO: 'go' };

export default {
  name: 'ChickenRoadGameField',
  components: {
    'spine': Spine,
    'spine-optimized': SpineOptimized
  },
  // Custom Filters replacing Angular Pipes
  filters: {
    itemImage(item) {
      return item?.image || '';
    },
    staticAssetUrl(path) {
      return path;
    }
  },

  props: {
    // Injected state management structures (from Vuex or props)
    chickenRoadState: {
      type: Object,
      required: true
    },
    settingsState: {
      type: Object,
      default: {
        disableAnimations: false,
        disableChickenRoadSounds: false,
        disableChickenRoadMusic: false
      }
    },
    soundsService: {
      type: Object,
      required: false
    },
  },

  data() {
    return {
      currentGameStatus: 0,
      // Direct Signal Translations -> Component Data
      itemsVisible: true,
      currentAnimation: ChickenAnimations.IDLE,
      currentPlatform: -1,
      isJumping: false,
      chickenPositionX: 11,
      isChickenInitialized: true,
      jumpingToPlatform: null,

      visiblePlatformRange: { start: 0, end: 7 },
      visibleTrainRange: { start: 0, end: 2 },

      platformsLoadingEnabled: false,
      platformRenderVersion: 0,


      trainRenderEnabled: true,
      chickenRenderEnabled: true,
      isTrainVisible: true,
      isChickenVisible: true,
      chickenSpineKey: true,

      trainPosition: -66.8,
      platformStates: {},
      platformTransitionTimeouts: new Map(),
      gameWon: false,
      gameLost: false,
      debugInfo: null,
      debugMode: false,

      brokenSpines: new Set(),
      spineRetryAttempts: new Map(),
      isTrainSpineBroken: false,
      isChickenSpineBroken: false,

      // Internal State Flags & Non-Reactive Timers
      previousPlatform: -1,
      jumpStartedForMakeStep: false,
      pendingPlatformWinAfterStep: null,
      previousAnimationState: null,
      previousApiStep: -1,
      pendingGameStatus: null,
      gameStatusHandled: false,
      lastHandledGameId: null,
      isAnimatingJump: false,

      // Audio & Animation References
      trainSoundHowl: null,
      ambientSoundHowl: null,
      winSoundHowl: null,
      loseSoundHowl: null,
      idleSoundHowl: null,
      wasTrainVisible: false,
      trainAnimationId: null,
      trainStartTime: null,
      lastJumpSound: null,
      pendingIdleSound: false,
      lastIdleSoundTime: 0,
      gameFieldScrollFrameId: null,

      // Resize & Observer Tracking
      resizeObserver: null,
      resizeTimeout: null,
      lastResizeWidth: 0,
      lastResizeHeight: 0,
      chickenSpineRetryTimer: null,
      trainSpineRetryAttempt: 0,
      chickenSpineRetryAttempt: 0,
      unlockHandler: null,

      pendingAnimationFrames: new Set(),
      pendingTimeouts: new Set(),

      // Constants
      TRAIN_WIDTH: 66.8,
      TRAIN_DURATION: 19200,
      TRAIN_FADE_DURATION: 1500,
      AMBIENT_FADE_DURATION: 2000,
      STATIC_JUMP_DURATION: 400,
      STATIC_PAUSE_DURATION: 150,
      STATIC_ITEM_DELAY_1: 300,
      STATIC_ITEM_DELAY_2: 300,
      STATIC_ITEM_DELAY_3: 400,
      CHICKEN_WIDTH: 18.75,
      CHICKEN_HEIGHT: 18.75,
      CHICKEN_CONTAINER_WIDTH: 75,
      PLATFORM_HEIGHT: 20,
      IDLE_SOUND_THROTTLE: 500,
      MAX_SPINE_RETRY_ATTEMPTS: 3,

      // Exported Enums for Template Access
      ChickenAnimations,
      PlatformAnimations,
      TrainAnimations,
      GameStatus
    };
  },

  computed: {
    isLg() {
      return this.$screen.mobile;
    },
    shouldShowItems() {
      const currentGame = this.chickenRoadState.currentGame;
      const isInProgress = currentGame?.status === GameStatus.IN_PROGRESS;
      return isInProgress ? true : this.itemsVisible;
    },
    PLATFORM_WIDTH() {
      return this.isLg ? 6.16 : 14;
    },
    PLATFORM_GAP() {
      return this.isLg ? 0.7 : 1.4;
    },
    CONTAINER_PADDING() {
      return this.isLg ? 10.15 : 21;
    },
    PLATFORM_BUFFER_SIZE() {
      return this.isLg ? 1 : 2;
    },
    PLATFORMS_BEHIND_CHICKEN() {
      return this.isLg ? 2 : 3;
    },
    PLATFORMS_AHEAD_CHICKEN() {
      return this.isLg ? 2 : 3;
    },
    initialChickenPosition() {
      return this.isLg ? 3.85 : 7.7;
    },
    basePlatformPositions() {
      return this.calculatePlatformPositions();
    },
    allPlatforms() {
      const mode = this.chickenRoadState.selectedMode;
      const coefficients = this.chickenRoadState.coefficients[mode];
      if (!coefficients) return [];
      console.log('Coefficients for mode', mode, coefficients);
      const currentGame = this.chickenRoadState.currentGame;
      const gameAmount = currentGame?.amount;
      const betAmount = gameAmount ? parseFloat(gameAmount) : 0;
      const steps = currentGame?.steps || [];
      const currentPlatformIndex = this.currentPlatform;
      const isGameStarted = currentGame?.status === GameStatus.IN_PROGRESS;

      return Array.from({ length: 20 }, (_, i) => {
        const stepData = steps[i];
        const item = stepData && 'item' in stepData ? stepData.item : null;
        const placeholderItemIndex = !isGameStarted && !item ? ((i * 7 + 3) % 8) + 1 : undefined;

        return {
          id: i + 1,
          index: i,
          multiplier: coefficients[i].toFixed(2),
          price: betAmount > 0 ? (betAmount * coefficients[i]).toFixed(2) : null,
          skin: `Platform ${i + 1}`,
          item,
          placeholderItemIndex,
          isChickenOnPlatform: i === currentPlatformIndex
        };
      });
    },
    mockPlatforms() {
      const range = this.visiblePlatformRange;
      return this.allPlatforms.filter(p => p.index >= range.start && p.index <= range.end);
    },
    platformsByAnimation() {
      const groups = new Map();
      for (const platform of this.mockPlatforms) {
        const animKey = this.getPlatformAnimationKey(platform.index);
        if (!groups.has(animKey)) {
          groups.set(animKey, []);
        }
        groups.get(animKey).push(platform);
      }
      return groups;
    },
    virtualScrollSpacerWidth() {
      const range = this.visiblePlatformRange;
      const platformTotalWidth = this.PLATFORM_WIDTH + this.PLATFORM_GAP;
      return range.start * platformTotalWidth;
    },
    totalPlatformsWidth() {
      const totalPlatforms = this.allPlatforms.length;
      return (this.PLATFORM_WIDTH + this.PLATFORM_GAP) * totalPlatforms - this.PLATFORM_GAP + this.CONTAINER_PADDING * 2;
    },
    visibleTrains() {
      const range = this.visibleTrainRange;
      return Array.from({ length: range.end - range.start + 1 }, (_, i) => range.start + i);
    },
    trainAnimation() {
      return TrainAnimations.GO;
    },
    staticChickenImage() {
      const game = this.chickenRoadState.currentGame;
      return game?.status === GameStatus.WON
        ? require(`./assets/chicken-win.png`)
        : require(`./assets/chicken.png`);
    }
  },

  watch: {
    // Watchers translating Angular Effects
    'chickenRoadState.isMakingStep': function (isMakingStep) {
      const currentGame = this.chickenRoadState.currentGame;

      if (!isMakingStep) {
        this.jumpStartedForMakeStep = false;
        this.flushPendingPlatformWinAfterStep();
        return;
      }

      if (this.jumpStartedForMakeStep || this.isJumping || this.isAnimatingJump || !currentGame) {
        return;
      }

      const currentStep = currentGame.currentStep;
      const nextPlatform = currentStep;

      if (nextPlatform === this.currentPlatform) {
        return;
      }

      const isJackpotJump = nextPlatform === 19 && currentStep === 20 && currentGame.status === GameStatus.WON;
      if (!isJackpotJump && currentGame.status !== GameStatus.IN_PROGRESS) {
        return;
      }

      if (currentStep === 0 && this.previousPlatform !== -1) {
        this.previousPlatform = -1;
      }

      if (this.previousPlatform >= 0) {
        this.setTrackedTimeout(() => {
          this.returnItemToPlatform(this.previousPlatform);
        }, 100);
      }

      const itemDelay = this.settingsState.disableAnimations ? this.STATIC_ITEM_DELAY_1 : 50;
      this.setTrackedTimeout(() => {
        this.animateItemToCorner(nextPlatform);
      }, itemDelay);

      this.jumpStartedForMakeStep = true;
      this.jumpingToPlatform = nextPlatform;
      this.isJumping = true;
      this.currentPlatform = nextPlatform;
    },

    currentPlatform: function (platform) {
      if (this.isJumping && platform >= 0 && !this.isAnimatingJump) {
        const currentGame = this.chickenRoadState.currentGame;
        const isJackpotJump = platform === 19 && currentGame?.currentStep === 20;

        if (!isJackpotJump && (currentGame?.status === GameStatus.WON || currentGame?.status === GameStatus.LOST)) {
          this.isJumping = false;
          return;
        }

        let fromPlatform = this.previousPlatform;
        if (platform === 0 && fromPlatform !== -1) {
          fromPlatform = -1;
          this.previousPlatform = -1;
        }
        this.startJumpAnimation(fromPlatform, platform);
      }
    },

    'chickenRoadState.currentGame': {
      deep: true,
      handler(game) {
        if (!game) {
          this.handleGameReset();
          this.setTrackedTimeout(() => {
            this.itemsVisible = false;
          }, 500);
          return;
        }

        const apiStep = game.currentStep;

        if (apiStep === 0 && game.status === GameStatus.IN_PROGRESS) {
          this.handleGameStart();
          return;
        }

        if (game.status === GameStatus.WON || game.status === GameStatus.LOST) {
          this.handleFinishedGame(game, apiStep);
          return;
        }

        if (game.status === GameStatus.IN_PROGRESS) {
          this.itemsVisible = true;
        }

        if (this.previousApiStep === -1 && apiStep > 0 && game.status === GameStatus.IN_PROGRESS) {
          this.initializeChickenPosition(apiStep);
        } else if (apiStep > this.previousApiStep && game.status === GameStatus.IN_PROGRESS) {
          this.previousApiStep = apiStep;
        }
      }
    },

    'settingsState.disableAnimations': function (animationsDisabled) {
      if (!animationsDisabled && !this.wasTrainVisible) {
        this.playTrainSoundWithFadeIn();
        this.startTrainAnimation();
        this.wasTrainVisible = true;
      } else if (animationsDisabled && this.wasTrainVisible) {
        this.stopTrainSoundWithFadeOut();
        this.stopTrainAnimation();
        this.wasTrainVisible = false;
      }

      if (this.previousAnimationState === null) {
        this.previousAnimationState = animationsDisabled;
        return;
      }

      const wasDisabledNowEnabled = this.previousAnimationState === true && animationsDisabled === false;
      this.previousAnimationState = animationsDisabled;

      if (wasDisabledNowEnabled) {
        const currentGame = this.chickenRoadState.currentGame;
        if (currentGame && Object.keys(this.platformStates).length > 0) {
          this.reapplyPlatformStatesOnAnimationEnable();
        }
      }
    },

    'settingsState.disableChickenRoadSounds': function (soundsDisabled) {
      if (soundsDisabled) {
        this.stopIdleSound();
        this.stopTrainSound();
      }
    },

    'settingsState.disableChickenRoadMusic': function (musicDisabled) {
      if (musicDisabled) {
        this.stopAmbientSound();
        return;
      }
      if (!this.ambientSoundHowl?.playing()) {
        this.playAmbientSound();
      }
    }
  },

  created() {
    this.chickenPositionX = this.initialChickenPosition;
  },

  mounted() {
    if (this.$refs.gameField) {
      this.$refs.gameField.addEventListener('scroll', this.onGameFieldScroll, { passive: true });
      this.setupResizeObserver();
    }

    this.updateVisibleRange();
    this.preloadIdleSound();
    this.setupAudioUnlock();

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(() => {
        this.platformsLoadingEnabled = true;
      }, { timeout: 100 });
    } else {
      this.setTrackedTimeout(() => {
        this.platformsLoadingEnabled = true;
      }, 50);
    }

    if (!this.settingsState.disableAnimations) {
      if (!this.settingsState.disableChickenRoadSounds) {
        this.playTrainSoundWithFadeIn();
      }
      this.startTrainAnimation();
      this.wasTrainVisible = true;
    }

    if (!this.settingsState.disableChickenRoadSounds && !this.settingsState.disableChickenRoadMusic) {
      this.playAmbientSound();
    }
  },

  beforeDestroy() {
    this.stopIdleSound();
    this.stopTrainSound();
    this.stopTrainAnimation();
    this.stopAmbientSound();

    if (this.winSoundHowl) this.winSoundHowl.stop();
    if (this.loseSoundHowl) this.loseSoundHowl.stop();

    this.clearAllPlatformTransitionTimeouts();
    this.removeUnlockHandlers();

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.resizeTimeout) clearTimeout(this.resizeTimeout);
    if (this.chickenSpineRetryTimer) clearTimeout(this.chickenSpineRetryTimer);

    this.clearPendingAnimationFrames();
    this.clearPendingTimeouts();
    this.cleanupGameFieldScrollListener();
  },

  methods: {
    isPlatformSpineActive(index) {
      // 1. 判断 platform 索引是否处于屏幕可视区间内（含缓冲区）
      const isInViewport = index >= this.visiblePlatformRange.start && index <= this.visiblePlatformRange.end;

      // 2. 正在触发结算动画（WIN / LOSE / IDLE-PENDING）的平台保留 Spine
      const state = this.platformStates[index];
      const isAnimatingState = state === 'win' || state === 'lose' || state === 'idle-pending';

      return isInViewport || isAnimatingState;
    },
    onSpineRetrySuccess(platformIndex) {
      // 1. 从 brokenSpines (Set) 中移除索引
      // 注意：Vue 2 无法拦截 Set 的 delete 方法，需要重新赋值 Set 实例来触发响应式更新
      const newSet = new Set(this.brokenSpines);
      newSet.delete(platformIndex);
      this.brokenSpines = newSet;

      this.spineRetryAttempts.delete(platformIndex);
    },
    getStaticPlatformImage(index) {
      const state = this.platformStates[index];
      if (!state) {
        return require(`./assets/platform.png`);
      }

      return require(`./assets/platform-${state}.png`);
    },
    calculatePlatformPositions() {
      const positions = [];
      const platformWidth = this.PLATFORM_WIDTH;
      const gap = this.PLATFORM_GAP;
      const padding = this.CONTAINER_PADDING;

      for (let i = 0; i < 21; i++) {
        const centerX = padding + (platformWidth + gap) * i + platformWidth / 2;
        positions.push(centerX);
      }
      return positions;
    },

    onGameFieldScroll() {
      if (this.isJumping || this.isAnimatingJump || this.gameFieldScrollFrameId !== null) {
        return;
      }
      this.gameFieldScrollFrameId = this.requestTrackedAnimationFrame(() => {
        this.gameFieldScrollFrameId = null;
        this.updateVisibleRange();
      });
    },

    handleGameStart() {
      this.resetChickenPosition();
      this.itemsVisible = true;
      this.gameStatusHandled = false;
      this.lastHandledGameId = null;
      this.previousPlatform = -1;

      this.setTrackedTimeout(() => {
        if (this.$refs.gameField) {
          this.$refs.gameField.scrollTo({ left: 0, behavior: 'smooth' });
        }
      }, 0);
      this.previousApiStep = 0;
    },

    handleFinishedGame(game, apiStep) {
      if (!this.isChickenInitialized && apiStep > 0) {
        const targetPlatform = apiStep - 1;
        const targetPositionRem = this.basePlatformPositions[targetPlatform];

        this.chickenPositionX = targetPositionRem;
        this.currentPlatform = targetPlatform;
        this.previousPlatform = targetPlatform;
        this.isChickenInitialized = true;
        this.scrollToChicken(targetPositionRem);

        this.requestTrackedAnimationFrame(() => {
          this.requestTrackedAnimationFrame(() => {
            this.setTrackedTimeout(() => {
              this.markPlatformsAsWin(0, targetPlatform + 1);
            }, 100);
          });
        });

        if (targetPlatform >= 0) {
          const itemDelay = this.settingsState.disableAnimations ? this.STATIC_ITEM_DELAY_2 : 100;
          this.setTrackedTimeout(() => {
            this.requestTrackedAnimationFrame(() => {
              this.requestTrackedAnimationFrame(() => {
                this.animateItemToCorner(targetPlatform);
              });
            });
          }, itemDelay);
        }
      }

      if (this.lastHandledGameId === game.id) return;

      if (this.isJumping || this.isAnimatingJump) {
        this.pendingGameStatus = { status: game.status, apiStep };
      } else {
        this.gameStatusHandled = true;
        this.handleGameStatus(game, apiStep);
      }
    },

    handleGameStatus(game, apiStep) {
      let platformIndex = this.currentPlatform;
      if (platformIndex < 0) {
        platformIndex = apiStep > 0 ? apiStep - 1 : 0;
      }

      if (game.status === GameStatus.WON) {
        this.lastHandledGameId = game.id;
        this.stopIdleSound();
        this.playWinSound();
        this.currentAnimation = ChickenAnimations.VICTORY;
        this.gameWon = true;
        this.markPlatformAsWinDirect(platformIndex);
      } else if (game.status === GameStatus.LOST) {
        this.lastHandledGameId = game.id;
        this.stopIdleSound();
        this.playLoseSound();
        this.currentAnimation = ChickenAnimations.DEAD;
        this.gameLost = true;
        this.markPlatformAsLose(platformIndex);
      } else if (game.status === GameStatus.IN_PROGRESS && apiStep > 0) {
        const hasWinStates = Array.from({ length: platformIndex }, (_, i) => i).some(
          (i) => this.platformStates[i] === 'win' || this.platformStates[i] === 'idle-pending'
        );
        if (hasWinStates) {
          this.markPlatformsAsWinDirect(0, platformIndex);
        } else {
          this.markPlatformsAsWin(0, platformIndex);
        }
      }
    },

    startJumpAnimation(fromPlatform, toPlatform) {
      if (this.isAnimatingJump) return;

      const currentGame = this.chickenRoadState.currentGame;
      const isJackpotJump = toPlatform === 19 && currentGame?.currentStep === 20;

      if (!isJackpotJump && (currentGame?.status === GameStatus.WON || currentGame?.status === GameStatus.LOST)) {
        return;
      }

      this.isAnimatingJump = true;
      this.chickenRoadState.isAnimating = true;
      this.stopIdleSound();

      const isFirstJump = fromPlatform === -1;
      const isBigJump = isFirstJump || isJackpotJump;
      const jumpAnimation = isBigJump ? ChickenAnimations.JUMP_BIG : ChickenAnimations.JUMP;

      if (jumpAnimation === ChickenAnimations.JUMP_BIG) {
        this.playBigJumpSound();
      } else {
        this.playNormalJumpSound();
      }

      const targetPlatform = Math.min(toPlatform, this.basePlatformPositions.length - 1);
      this.currentAnimation = jumpAnimation;

      this.setTrackedTimeout(
        () => this.handleJumpLanding(targetPlatform),
        this.settingsState.disableAnimations ? this.STATIC_JUMP_DURATION : 1000
      );
    },

    handleJumpLanding(targetPlatform) {
      const gameAfterAnimation = this.chickenRoadState.currentGame;
      if (!gameAfterAnimation) {
        this.isAnimatingJump = false;
        this.chickenRoadState.isAnimating = false;
        this.isJumping = false;
        return;
      }

      const targetPositionRem = this.basePlatformPositions[targetPlatform];
      this.chickenPositionX = targetPositionRem;
      this.currentPlatform = targetPlatform;

      const finalGameStatus = gameAfterAnimation.status;
      if (finalGameStatus === GameStatus.LOST) {
        this.handleLostGame(targetPlatform, gameAfterAnimation);
        return;
      }

      const isJackpotWin = finalGameStatus === GameStatus.WON && gameAfterAnimation.currentStep === 20 && targetPlatform === 19;
      if (isJackpotWin) {
        this.handleInProgressGame(targetPlatform);
      } else if (finalGameStatus === GameStatus.IN_PROGRESS) {
        if (this.chickenRoadState.isMakingStep) {
          this.pendingPlatformWinAfterStep = targetPlatform;
          this.currentAnimation = ChickenAnimations.IDLE;
        } else {
          this.handleInProgressGame(targetPlatform);
        }
      }

      this.scrollToChicken(targetPositionRem);
      const pauseDuration = this.settingsState.disableAnimations ? this.STATIC_PAUSE_DURATION : 400;
      this.setTrackedTimeout(() => {
        this.handlePostJumpCleanup(targetPlatform, pauseDuration);
      }, pauseDuration);
    },

    handlePostJumpCleanup(targetPlatform) {
      const oldPreviousPlatform = this.previousPlatform;
      if (oldPreviousPlatform >= 0 && oldPreviousPlatform !== targetPlatform) {
        this.returnItemToPlatform(oldPreviousPlatform);
      }

      this.previousPlatform = targetPlatform;
      this.jumpingToPlatform = null;
      this.isJumping = false;
      this.isAnimatingJump = false;
      this.chickenRoadState.isAnimating = false;
      this.currentPlatform = targetPlatform;
      this.isChickenVisible = true;

      this.updateVisibleRange();

      const game = this.chickenRoadState.currentGame;
      if (game) this.previousApiStep = game.currentStep;

      if (this.pendingGameStatus) {
        const pending = this.pendingGameStatus;
        this.pendingGameStatus = null;
        if (game && this.lastHandledGameId !== game.id) {
          this.gameStatusHandled = true;
          this.handleGameStatus(game, pending.apiStep);
        }
      } else if (game) {
        const isGameFinished = game.status === GameStatus.WON || game.status === GameStatus.LOST;
        if (isGameFinished && this.lastHandledGameId !== game.id) {
          this.gameStatusHandled = true;
          this.handleGameStatus(game, game.currentStep);
        }
      }
    },

    handleInProgressGame(targetPlatform) {
      this.pendingPlatformWinAfterStep = null;
      this.markPlatformAsWinWithIdleTransition(targetPlatform, 300);

      const currentGame = this.chickenRoadState.currentGame;
      const isLandingOnLastPlatform = targetPlatform === 19 && currentGame?.currentStep === 20;

      if (isLandingOnLastPlatform) {
        this.currentAnimation = ChickenAnimations.IDLE;
        const delayBeforeJackpot = this.settingsState.disableAnimations ? 200 : 500;
        this.setTrackedTimeout(() => {
          this.handleJackpotJump(targetPlatform);
        }, delayBeforeJackpot);
      } else {
        this.currentAnimation = ChickenAnimations.IDLE;
      }
    },

    handleLostGame(targetPlatform, game) {
      this.jumpingToPlatform = null;
      this.isJumping = false;
      this.isAnimatingJump = false;
      this.chickenRoadState.isAnimating = false;
      this.previousPlatform = targetPlatform;
      this.isChickenVisible = true;
      this.updateVisibleRange();

      if (this.lastHandledGameId !== game.id) {
        this.gameStatusHandled = true;
        this.handleGameStatus(game, game.currentStep);
      }
    },

    scrollToChicken(positionRem) {
      if (!this.$refs.gameField) return;
      const container = this.$refs.gameField;
      const remSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
      const chickenCenterPx = positionRem * remSize;
      const viewportWidth = container.clientWidth;
      const maxScroll = container.scrollWidth - container.clientWidth;
      const desiredScrollLeft = chickenCenterPx - viewportWidth / 2;
      const finalScrollLeft = Math.max(0, Math.min(desiredScrollLeft, maxScroll));

      if (Math.abs(container.scrollLeft - finalScrollLeft) > 5) {
        container.scrollTo({ left: finalScrollLeft, behavior: 'smooth' });
        this.setTrackedTimeout(() => {
          if (!this.isJumping && !this.isAnimatingJump) {
            this.updateVisibleRange();
          }
        }, 350);
      }
    },

    /**
     * 更新可视区域及滚动逻辑
     */
    updateVisibleRange() {
      if (!this.$refs.gameField) return;

      const container = this.$refs.gameField;
      const PX_PER_REM = parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;
      const scrollLeftRem = container.scrollLeft / PX_PER_REM;
      const containerWidthRem = container.clientWidth / PX_PER_REM;

      this.updatePlatformRange();
      this.updateTrainRange(scrollLeftRem, containerWidthRem);
      this.isTrainVisible = true;
      this.isChickenVisible = true;
    },

    /**
     * 基于游戏背景窗口容器 (gameField) 精确计算可视平台范围
     */
    updatePlatformRange() {
      const container = this.$refs.gameField; // 1. 修复：使用正确的 ref
      if (!container) return;

      // 获取背景视口的实际尺寸与滚动位置
      const viewportWidthPx = container.clientWidth;
      const scrollLeftPx = container.scrollLeft;

      const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
      const scrollLeftRem = scrollLeftPx / rootFontSize;
      const viewportWidthRem = viewportWidthPx / rootFontSize;

      const platformDistance = this.PLATFORM_WIDTH + this.PLATFORM_GAP;
      const buffer = this.PLATFORM_BUFFER_SIZE;

      const relativeStartRem = Math.max(0, scrollLeftRem - this.CONTAINER_PADDING);
      const relativeEndRem = relativeStartRem + viewportWidthRem;

      let startPlatform = Math.max(0, Math.floor(relativeStartRem / platformDistance) - buffer);
      let endPlatform = Math.min(19, Math.ceil(relativeEndRem / platformDistance) + buffer);

      // 2. 核心修复：确保小鸡当前所在平台及正在跳跃的目标平台永远留在 DOM 内，防止跳跃时目标平台消失
      const activePlatform = this.jumpingToPlatform !== null ? this.jumpingToPlatform : this.currentPlatform;
      if (activePlatform >= 0) {
        startPlatform = Math.min(startPlatform, Math.max(0, activePlatform - buffer));
        endPlatform = Math.max(endPlatform, Math.min(19, activePlatform + buffer));
      }

      if (this.visiblePlatformRange.start !== startPlatform || this.visiblePlatformRange.end !== endPlatform) {
        this.visiblePlatformRange = { start: startPlatform, end: endPlatform };
      }
    },

    updateTrainRange(scrollLeftRem, containerWidthRem) {
      const trainWidth = 66.8;
      const startTrain = Math.max(0, Math.floor(scrollLeftRem / trainWidth) - 1);
      const endTrain = Math.min(4, Math.ceil((scrollLeftRem + containerWidthRem) / trainWidth) + 1);
      this.visibleTrainRange = { start: startTrain, end: endTrain };
    },

    markPlatformAsWinWithIdleTransition(platformIndex, delayMs = 300) {
      // 安全获取 timeout
      const existingTimeout = this.platformTransitionTimeouts?.get(platformIndex);
      if (existingTimeout) clearTimeout(existingTimeout);

      this.$set(this.platformStates, platformIndex, 'idle-pending');

      const timeoutId = setTimeout(() => {
        this.$set(this.platformStates, platformIndex, 'win');
        this.platformTransitionTimeouts.delete(platformIndex);
      }, delayMs);

      this.platformTransitionTimeouts.set(platformIndex, timeoutId);
    },

    markPlatformAsLose(platformIndex) {
      this.pendingPlatformWinAfterStep = null;
      this.$set(this.platformStates, platformIndex, 'lose');
    },

    markPlatformAsWinDirect(platformIndex) {
      this.pendingPlatformWinAfterStep = null;
      this.$set(this.platformStates, platformIndex, 'win');
    },

    markPlatformsAsWin(startIndex, endIndex) {
      for (let i = startIndex; i < endIndex; i++) {
        if (this.platformStates[i] !== 'lose') {
          this.markPlatformAsWinWithIdleTransition(i, 300 + (i - startIndex) * 100);
        }
      }
    },

    markPlatformsAsWinDirect(startIndex, endIndex) {
      for (let i = startIndex; i < endIndex; i++) {
        if (this.platformStates[i] !== 'lose') {
          this.$set(this.platformStates, i, 'win');
        }
      }
    },

    returnItemToPlatform(platformIndex) {
      if (!this.$refs.gameField) return;
      const platformBox = this.$refs.gameField.querySelector(`[data-platform-index="${platformIndex}"]`);
      const platformItem = platformBox?.querySelector('.platform-item');
      if (!platformItem) return;

      platformItem.classList.remove('platform-item--above');
      const initialWidth = this.isLg ? '3.7rem' : '8.4rem';
      const initialHeight = this.isLg ? '2.77rem' : '6.3rem';
      const initialTop = this.isLg ? '1.89rem' : '4.2rem';
      const transition = this.settingsState.disableAnimations ? 'none' : 'transform 0.8s ease-out, width 0.8s ease-out, height 0.8s ease-out, top 0.8s ease-out, z-index 0.8s ease-out';

      this.requestTrackedAnimationFrame(() => {
        platformItem.style.transition = transition;
        platformItem.style.transform = 'translate(-50%, -50%) scale(1)';
        platformItem.style.width = initialWidth;
        platformItem.style.height = initialHeight;
        platformItem.style.top = initialTop;
        platformItem.style.zIndex = '3';
      });
    },

    animateItemToCorner(platformIndex) {
      if (!this.$refs.gameField) return;
      const platformBox = this.$refs.gameField.querySelector(`[data-platform-index="${platformIndex}"]`);
      const platformItem = platformBox?.querySelector('.platform-item');
      if (!platformItem) return;

      const remSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
      const deltaYRem = this.isLg ? -3 : -7;
      const deltaXRem = this.isLg ? -3 : -7;
      const targetWidth = this.isLg ? '2.45rem' : '5.6rem';
      const targetHeight = this.isLg ? '1.82rem' : '4.2rem';

      const transition = this.settingsState.disableAnimations ? 'none' : 'transform 0.8s ease-out, width 0.8s ease-out, height 0.8s ease-out';

      this.requestTrackedAnimationFrame(() => {
        platformItem.style.transition = transition;
        platformItem.style.transform = `translate(calc(-50% + ${deltaXRem * remSize}px), calc(-50% + ${deltaYRem * remSize}px)) scale(0.75)`;
        platformItem.style.width = targetWidth;
        platformItem.style.height = targetHeight;
        platformItem.style.zIndex = '1000';
      });
    },

    getPlatformAnimation(platformIndex) {
      const state = this.platformStates[platformIndex];
      const isGold = platformIndex >= 15;
      const group = Math.floor(platformIndex / 5);

      if (state === 'idle-pending' || !state) {
        switch (group) {
          case 0: return PlatformAnimations.IDLE_NORMAL;
          case 1: return PlatformAnimations.IDLE_BLUE;
          case 2: return PlatformAnimations.IDLE_PURPLE;
          case 3: return PlatformAnimations.IDLE_GOLD;
          default: return PlatformAnimations.IDLE_NORMAL;
        }
      }

      if (state === 'win') return isGold ? PlatformAnimations.WIN_GOLD : PlatformAnimations.WIN;
      if (state === 'lose') return isGold ? PlatformAnimations.LOSE_GOLD : PlatformAnimations.LOSE;

      return PlatformAnimations.IDLE_NORMAL;
    },

    isPlatformLooped(platformIndex) {
      const state = this.platformStates[platformIndex];
      return state !== 'win' && state !== 'lose';
    },

    getPlatformFPS(platformIndex) {
      return Math.abs(platformIndex - this.currentPlatform) <= 1 ? 60 : 15;
    },

    shouldShowItemOnPlatform(platformIndex) {
      return this.platformStates[platformIndex] !== 'lose';
    },

    getPlatformAnimationKey(platformIndex) {
      return `${this.getPlatformAnimation(platformIndex)}`;
    },

    // Audio Methods
    preloadIdleSound() {
      if (!this.soundsService) {
        console.warn('soundsService 未初始化，跳过播放');
        return;
      }

      const howl = this.soundsService.playSound('chicken-road-afk', 0, false);
      if (howl) howl.once('load', () => howl.stop());
    },

    playIdleSound() {
      if (Howler.ctx && Howler.ctx.state === 'suspended') {
        this.pendingIdleSound = true;
        Howler.ctx.resume().then(() => {
          if (this.pendingIdleSound && this.currentAnimation === ChickenAnimations.IDLE) {
            this.pendingIdleSound = false;
            this.doPlayIdleSound();
          }
        }).catch(() => { });
        return;
      }
      this.doPlayIdleSound();
    },

    doPlayIdleSound() {
      if (this.settingsState.disableChickenRoadSounds) return;
      const now = Date.now();
      if (now - this.lastIdleSoundTime < this.IDLE_SOUND_THROTTLE || this.idleSoundHowl?.playing()) return;

      this.stopIdleSound();
      this.idleSoundHowl = this.soundsService.playSound('chicken-road-afk', 1, false);
      if (this.idleSoundHowl) {
        this.lastIdleSoundTime = now;
        this.pendingIdleSound = false;
      } else {
        this.pendingIdleSound = true;
      }
    },

    stopIdleSound() {
      if (this.idleSoundHowl) {
        this.idleSoundHowl.stop();
        this.idleSoundHowl = null;
      }
      this.soundsService.stop('chicken-road-afk', false);
    },

    playTrainSoundWithFadeIn() {
      if (this.settingsState.disableChickenRoadSounds || this.trainSoundHowl?.playing()) return;
      this.stopTrainSound();
      this.trainSoundHowl = this.soundsService.playSound('chicken-road-train', 0, false);
      if (this.trainSoundHowl) this.trainSoundHowl.fade(0, 0.7, this.TRAIN_FADE_DURATION);
    },

    stopTrainSoundWithFadeOut() {
      if (this.trainSoundHowl && this.trainSoundHowl.playing()) {
        const howl = this.trainSoundHowl;
        howl.fade(howl.volume(), 0, this.TRAIN_FADE_DURATION);
        this.setTrackedTimeout(() => howl.stop(), this.TRAIN_FADE_DURATION);
      }
      this.trainSoundHowl = null;
    },

    stopTrainSound() {
      if (this.trainSoundHowl) {
        this.trainSoundHowl.stop();
        this.trainSoundHowl = null;
      }
    },

    startTrainAnimation() {

      if (this.trainAnimationId !== null) return;
      this.trainStartTime = performance.now();
      this.trainPosition = -this.TRAIN_WIDTH;
      this.animateTrain();
    },

    stopTrainAnimation() {
      if (this.trainAnimationId !== null) {
        this.cancelTrackedAnimationFrame(this.trainAnimationId);
        this.trainStartTime = null;
        this.trainAnimationId = null;
      }
    },

    animateTrain() {
      if (!this.trainStartTime || !this.$refs.gameField) return;
      const elapsed = performance.now() - this.trainStartTime;
      const remSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
      const containerWidthRem = this.$refs.gameField.offsetWidth / remSize;

      const startPos = -this.TRAIN_WIDTH;
      const endPos = containerWidthRem + this.TRAIN_WIDTH * 2;
      const currentPos = startPos + (endPos - startPos) * (elapsed / this.TRAIN_DURATION);

      if (currentPos >= endPos) {
        this.trainStartTime = performance.now();
        this.trainPosition = -this.TRAIN_WIDTH;
        if (!this.settingsState.disableChickenRoadSounds) {
          this.stopTrainSound();
          this.trainSoundHowl = this.soundsService.playSound('chicken-road-train', 0, false);
          if (this.trainSoundHowl) this.trainSoundHowl.fade(0, 0.7, this.TRAIN_FADE_DURATION);
        }
      } else {
        this.trainPosition = currentPos;
      }
      this.trainAnimationId = this.requestTrackedAnimationFrame(() => this.animateTrain());
    },

    playAmbientSound() {
      if (this.ambientSoundHowl?.playing()) return;
      this.stopAmbientSound();
      this.ambientSoundHowl = this.soundsService.playSound('chicken-road-ambient', 0, true);
      if (this.ambientSoundHowl) this.ambientSoundHowl.fade(0, 0.3, this.AMBIENT_FADE_DURATION);
    },

    stopAmbientSound() {
      if (this.ambientSoundHowl) {
        this.ambientSoundHowl.stop();
        this.ambientSoundHowl = null;
      }
    },

    playNormalJumpSound() {
      if (this.settingsState.disableChickenRoadSounds) return;
      const availableSounds = [1, 2, 3];
      const soundsToChoose = this.lastJumpSound !== null ? availableSounds.filter(s => s !== this.lastJumpSound) : availableSounds;
      const selectedSound = soundsToChoose[Math.floor(Math.random() * soundsToChoose.length)];
      this.soundsService.playSound(`chicken-road-jump-${selectedSound}`);
      this.lastJumpSound = selectedSound;
    },

    playBigJumpSound() {
      if (!this.settingsState.disableChickenRoadSounds) {
        this.soundsService.playSound('chicken-road-jump-4');
      }
    },

    playLoseSound() {
      if (!this.settingsState.disableChickenRoadSounds && !this.loseSoundHowl?.playing()) {
        if (this.loseSoundHowl) this.loseSoundHowl.stop();
        this.loseSoundHowl = this.soundsService.playSound('chicken-road-lose');
      }
    },

    playWinSound() {
      if (!this.settingsState.disableChickenRoadSounds && !this.winSoundHowl?.playing()) {
        if (this.winSoundHowl) this.winSoundHowl.stop();
        this.winSoundHowl = this.soundsService.playSound('chicken-road-win');
      }
    },

    // Handlers for Spine Callbacks
    onChickenAnimationStart(name) {
      if (name === ChickenAnimations.IDLE) this.playIdleSound();
    },

    onChickenAnimationLoopComplete(name) {
      if (name === ChickenAnimations.IDLE) this.playIdleSound();
    },

    onChickenAnimationComplete() { },

    onTrainSpineError() {
      this.isTrainSpineBroken = true;

      // 延迟 1 秒后尝试重试
      this.setTrackedTimeout(() => {
        this.retryTrainSpine();
      }, 1000);
    },
    /**
     * 重新加载损坏的火车 Spine
     */
    retryTrainSpine() {
      if (this.trainSpineRetryAttempt >= this.MAX_SPINE_RETRY_ATTEMPTS) {
        return;
      }

      this.trainSpineRetryAttempt++;
    },
    /**
         * 重试后成功加载火车 Spine
         */
    onTrainSpineRetrySuccess() {
      this.isTrainSpineBroken = false;
      this.trainSpineRetryAttempt = 0;
      this.clearTrackedTimeout();
    },
    /**
         * 重试再次失败处理
         */
    onTrainSpineRetryFailed() {
      // 较大延迟（2秒）后再次尝试
      this.setTrackedTimeout(() => {
        this.retryTrainSpine();
      }, 2000);
    },

    /**
         * 小鸡 Spine 渲染/加载失败回调
         */
    onChickenSpineError() {
      this.isChickenSpineBroken = true;

      // 清理之前的定时器（如果有）
      if (this.chickenSpineRetryTimer) {
        clearTimeout(this.chickenSpineRetryTimer);
      }

      // 延迟 500ms 后重试
      this.chickenSpineRetryTimer = setTimeout(() => {
        this.retryChickenSpine();
      }, 500);
    },
    /**
     * 重试加载小鸡 Spine（通过销毁并重新挂载组件强制刷新）
     */
    retryChickenSpine() {
      if (this.chickenSpineRetryAttempt >= this.MAX_SPINE_RETRY_ATTEMPTS) {
        return;
      }

      this.chickenSpineRetryAttempt++;

      // 1. 强制卸载小鸡 Spine（相当于配合 v-if="chickenRenderEnabled" 销毁旧组件）
      this.chickenRenderEnabled = false;

      // 2. 嵌套两次 requestAnimationFrame，确保 DOM 和 WebGL 资源在上一帧被彻底清理完后，再重新挂载
      this.requestTrackedAnimationFrame(() => {
        this.requestTrackedAnimationFrame(() => {
          this.chickenRenderEnabled = true;

          // 3. 稍作延迟（100ms）后重置错误状态
          this.setTrackedTimeout(() => {
            this.isChickenSpineBroken = false;
          }, 100);
        });
      });
    },

    /**
 * 重试后成功加载小鸡 Spine
 */
    onChickenSpineRetrySuccess() {
      this.isChickenSpineBroken = false;
      this.chickenSpineRetryAttempt = 0;

      if (this.chickenSpineRetryTimer) {
        clearTimeout(this.chickenSpineRetryTimer);
        this.chickenSpineRetryTimer = null; // Vue 习惯中常使用 null 替代 undefined
      }
    },

    /**
     * 小鸡 Spine 重试再次失败回调
     */
    onChickenSpineRetryFailed() {
      // 较大延迟（1秒）后再次尝试
      if (this.chickenSpineRetryTimer) {
        clearTimeout(this.chickenSpineRetryTimer);
      }

      this.chickenSpineRetryTimer = setTimeout(() => {
        this.retryChickenSpine();
      }, 1000);
    },

    onPlatformSpineError(platformIndex) {
      this.brokenSpines.add(platformIndex);
    },

    // Utilities & Listeners Setup
    setupAudioUnlock() {
      this.unlockHandler = () => {
        if (Howler.ctx && Howler.ctx.state === 'suspended') {
          Howler.ctx.resume();
        }
        this.removeUnlockHandlers();
      };
      document.addEventListener('click', this.unlockHandler, { passive: true });
      document.addEventListener('touchstart', this.unlockHandler, { passive: true });
    },

    removeUnlockHandlers() {
      if (this.unlockHandler) {
        document.removeEventListener('click', this.unlockHandler);
        document.removeEventListener('touchstart', this.unlockHandler);
        this.unlockHandler = null;
      }
    },

    setupResizeObserver() {
      if (!this.$refs.gameField) return;
      this.resizeObserver = new ResizeObserver(entries => {
        const entry = entries[0];
        if (!entry) return;

        const { width, height } = entry.contentRect;
        if (Math.abs(width - this.lastResizeWidth) <= 1 && Math.abs(height - this.lastResizeHeight) <= 1) return;

        this.lastResizeWidth = width;
        this.lastResizeHeight = height;

        if (this.resizeTimeout) clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => {
          this.platformRenderVersion += 1;
          this.updateVisibleRange();
        }, 150);
      });
      this.resizeObserver.observe(this.$refs.gameField);
    },

    requestTrackedAnimationFrame(cb) {
      const frameId = requestAnimationFrame(timestamp => {
        this.pendingAnimationFrames.delete(frameId);
        cb(timestamp);
      });
      this.pendingAnimationFrames.add(frameId);
      return frameId;
    },

    cancelTrackedAnimationFrame(frameId) {
      if (frameId === null) return;
      cancelAnimationFrame(frameId);
      this.pendingAnimationFrames.delete(frameId);
    },

    clearPendingAnimationFrames() {
      this.pendingAnimationFrames.forEach(f => cancelAnimationFrame(f));
      this.pendingAnimationFrames.clear();
    },

    setTrackedTimeout(cb, delay) {
      const timeoutId = setTimeout(() => {
        this.pendingTimeouts.delete(timeoutId);
        cb();
      }, delay);
      this.pendingTimeouts.add(timeoutId);
      return timeoutId;
    },

    clearPendingTimeouts() {
      this.pendingTimeouts.forEach(t => clearTimeout(t));
      this.pendingTimeouts.clear();
    },

    clearAllPlatformTransitionTimeouts() {
      if (this.platformTransitionTimeouts) {
        this.platformTransitionTimeouts.forEach(t => clearTimeout(t));
        this.platformTransitionTimeouts.clear();
      } else {
        this.platformTransitionTimeouts = new Map();
      }
    },

    cleanupGameFieldScrollListener() {
      if (this.gameFieldScrollFrameId !== null) {
        this.cancelTrackedAnimationFrame(this.gameFieldScrollFrameId);
        this.gameFieldScrollFrameId = null;
      }
      if (this.$refs.gameField) {
        this.$refs.gameField.removeEventListener('scroll', this.onGameFieldScroll);
      }
    },
    resetChickenPosition() {
      this.currentPlatform = -1;
      this.previousPlatform = -1;
      this.jumpStartedForMakeStep = false;
      this.pendingPlatformWinAfterStep = null;
      this.chickenPositionX = this.initialChickenPosition;
      this.isJumping = false;
      this.isAnimatingJump = false;
      this.chickenRoadState.isAnimating = false;
      this.isChickenInitialized = true;

      this.clearAllPlatformTransitionTimeouts();
      this.platformStates = {};
      this.gameWon = false;
      this.gameLost = false;
      this.currentAnimation = ChickenAnimations.IDLE;

      if (this.$refs.gameField) {
        this.$refs.gameField.scrollTo({ left: 0, behavior: 'smooth' });
      }
    },

    handleGameReset() {

      if (this.previousPlatform >= 0) {
        this.returnItemToPlatform(this.previousPlatform);
      }

      if (this.previousApiStep !== -1) {
        this.clearAllPlatformTransitionTimeouts();
        this.platformStates = {};
        this.resetChickenPosition();
      }
      this.previousApiStep = -1;
    },

    initializeChickenPosition(apiStep) {
      const targetPlatform = apiStep - 1;
      const targetPositionRem = this.basePlatformPositions[targetPlatform];

      this.previousApiStep = apiStep;
      this.chickenPositionX = targetPositionRem;
      this.currentPlatform = targetPlatform;
      this.previousPlatform = targetPlatform;
      this.isJumping = false;
      this.currentAnimation = ChickenAnimations.IDLE;
      this.isChickenInitialized = true;
      this.scrollToChicken(targetPositionRem);

      this.requestTrackedAnimationFrame(() => {
        this.requestTrackedAnimationFrame(() => {
          this.setTrackedTimeout(() => {
            this.markPlatformsAsWin(0, targetPlatform + 1);
          }, 100);
        });
      });
    },

    flushPendingPlatformWinAfterStep() {
      if (this.pendingPlatformWinAfterStep === null || this.isJumping || this.isAnimatingJump) return;

      const platform = this.pendingPlatformWinAfterStep;
      const game = this.chickenRoadState.currentGame;

      if (game?.status === GameStatus.IN_PROGRESS) {
        this.pendingPlatformWinAfterStep = null;
        this.handleInProgressGame(platform);
      } else if (game?.status === GameStatus.LOST || game?.status === GameStatus.WON) {
        this.pendingPlatformWinAfterStep = null;
      }
    },

    reapplyPlatformStatesOnAnimationEnable() {
      const currentStates = new Map(this.platformStates);
      const winPlatforms = [];
      currentStates.forEach((state, idx) => {
        if (state === 'win') winPlatforms.push(idx);
      });

      if (winPlatforms.length === 0) return;
      this.clearAllPlatformTransitionTimeouts();

      this.requestTrackedAnimationFrame(() => {
        winPlatforms.forEach(idx => this.$set(this.platformStates, idx, 'idle-pending'));
        this.setTrackedTimeout(() => {
          winPlatforms.forEach(idx => this.$set(this.platformStates, idx, 'win'));
        }, 500);
      });
    }
  }
};
